export default "__VITE_ASSET__CT52EVRK__"